angular.module('zc.commonApi')

  .factory('CampaignStatsV2', CampaignStatsV2Service);

CampaignStatsV2Service.$inject = ['$q', 'FacadeV2'];
function CampaignStatsV2Service($q, FacadeV2) {
  const service = {
    find
  };

  return service;

  function find(paths = {}, query = {}, options = {}) {
    return $q((resolve, reject) => {
      if(!paths.apikey) {
        const errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if(!paths.dimension) {
        const errorMsg = 'No dimension';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      const promise = FacadeV2.request(`/apikeys/${paths.apikey}/campaign_stats/${paths.dimension}/find`, {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(res => {
        if(res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign stats'));
        } else {
          resolve(res.data);
        }
      });

      return promise;
    });
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/campaign_stats_v2.service.js